module.exports = __webpack_public_path__ + "02aa2cbd2e9e18fe788fba27c7b5d6ce.png";